import { render, staticRenderFns } from "./NewCompaniesList.vue?vue&type=template&id=56a60ad0&scoped=true&"
import script from "./NewCompaniesList.vue?vue&type=script&lang=js&"
export * from "./NewCompaniesList.vue?vue&type=script&lang=js&"
import style0 from "./NewCompaniesList.vue?vue&type=style&index=0&id=56a60ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a60ad0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
